
import ErrorBoundary from "@/components/ErrorBoundary";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { RefreshCw, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface RequestsErrorBoundaryProps {
  children: React.ReactNode;
  onRetry?: () => void;
}

export const RequestsErrorBoundary = ({ 
  children, 
  onRetry 
}: RequestsErrorBoundaryProps) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/admin/dashboard");
  };

  const RequestsErrorFallback = (
    <Alert variant="destructive" className="my-4">
      <AlertTitle>Kunde inte ladda förfrågningar</AlertTitle>
      <AlertDescription>
        <p className="mb-4">
          Det gick inte att hämta eller hantera gruppledare förfrågningar. 
          Vänligen försök igen eller återgå till dashboard.
        </p>
        <div className="flex gap-2">
          {onRetry && (
            <Button onClick={onRetry} size="sm" variant="outline">
              <RefreshCw className="h-4 w-4 mr-2" />
              Försök igen
            </Button>
          )}
          <Button onClick={handleGoHome} size="sm">
            <Home className="h-4 w-4 mr-2" />
            Till dashboard
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );

  return (
    <ErrorBoundary fallback={RequestsErrorFallback}>
      {children}
    </ErrorBoundary>
  );
};
